import { changeUrlSlug as changeUrlSlugCommon } from 'app-source/actions/changeUrlSlug';
import { googPalRequest } from 'app-modules/application/actions';
import { selectors, constants } from 'app-webtech-core';
import { WATCH_CHANNEL, WATCH } from '../../../routes/types';

export const changeUrlSlug = (channelSlug, query) => (dispatch, getState) => {
  let slug = channelSlug;
  const state = getState();
  if (!slug) {
    const { content } = selectors.player.properties(state);
    if (content.kind === constants.player.PLAYER_CONTENT_KIND.LINEAR_CHANNEL) {
      const channel = selectors.player.content(state);
      ({ slug } = channel);
    }
  }
  dispatch(googPalRequest());
  dispatch(changeUrlSlugCommon(WATCH_CHANNEL, WATCH)({ slug, query }));
};
